// A block that a refetch covers (revamp PR 5, decision #15 "refetch keeps the page"): the last data stays on screen at
// half opacity and the block is `aria-busy` until the new data arrives. ChartCard dims its own body and footer with it;
// use it for any other block on a dashboard (tiles, a list, a footer line). Recharts-free.
//
//   <Dimmed dimmed={refetching}>
//     <StatGrid cols={4}>…</StatGrid>
//   </Dimmed>
//   <Dimmed as="section" dimmed={loading} aria-labelledby={headingId} className="grid gap-2">…</Dimmed>
//
// The fade follows the reader's motion setting (no transition under prefers-reduced-motion).
import type { HTMLAttributes, ReactNode } from 'react';

import { cn } from '@/lib/utils';

export interface DimmedProps extends HTMLAttributes<HTMLElement> {
  /** A refetch is running and the children are the last data. */
  dimmed: boolean;
  /** The element to render (default `div`). */
  as?: 'div' | 'section';
  children?: ReactNode;
}

export function Dimmed({ dimmed, as: Tag = 'div', className, children, ...rest }: DimmedProps) {
  return (
    <Tag
      {...rest}
      aria-busy={dimmed || undefined}
      className={cn('transition-opacity motion-reduce:transition-none', dimmed && 'opacity-50', className)}
    >
      {children}
    </Tag>
  );
}
